<template>
  <!-- SKELETON -->
  <div v-if="loading" class="mb-8">
    <div class="relative rounded-2xl overflow-hidden h-84 bg-grey-light-200">
      <Skeleton class="absolute inset-0 w-full h-full" />
    </div>
  </div>

  <!-- REAL CARD -->
  <div v-else-if="id" class="mb-8">
    <div class="relative rounded-2xl overflow-hidden h-80 bg-grey-light-200">
      <img :src="logo" :alt="name" class="w-full h-full object-cover" />

      <div class="absolute inset-0 bg-linear-to-t from-black/60 to-transparent">
        <div class="absolute top-6 left-6">
          <div class="flex items-center gap-2 mb-2">
            <h2 class="text-white text-3xl font-bold">
              {{ name }}
            </h2>

            <span
              v-if="isNewStore(createdAt)"
              class="bg-blue-50 text-blue-700 text-xs font-semibold px-2 py-1 rounded-full"
            >
              New
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Skeleton } from '@/components/ui/skeleton';
import { isNewStore } from '@/utils/stores';

defineProps<{
  id: string | undefined;
  name: string | undefined;
  logo: string | undefined;
  createdAt: string | undefined;
  loading: boolean;
}>();
</script>
